var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "open-guide-page" },
    [
      _c("div", { staticClass: "hero" }, [
        _c("div", [
          _c("span", [_vm._v("OPEN GUIDE")]),
          _c("h2", [_vm._v("开店指南")]),
          _c("p", [
            _vm._v(
              "已完成 " +
                _vm._s(_vm.guide.doneSteps || 0) +
                "/" +
                _vm._s(_vm.guide.totalSteps || 0) +
                " 项。"
            ),
          ]),
        ]),
      ]),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.guide.items || [], size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "sort", label: "序号", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "步骤", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "说明",
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === "pending"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "complete")
                                  },
                                },
                              },
                              [_vm._v("完成")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "reset")
                                  },
                                },
                              },
                              [_vm._v("重置")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }